import { useInActivityTracker } from '../hooks/useInActivityTracker';
import PropTypes from 'prop-types';

const InActivityTracker = ({ children }) => {
  useInActivityTracker();
  return children;
};

InActivityTracker.propTypes = {
  children: PropTypes.node,
};

export default InActivityTracker;
